import React, { useState } from 'react';
import { SearchIcon, BuildingIcon, XIcon } from 'lucide-react';
import { Input } from '../../ui/Input';
import { Badge } from '../../ui/Badge';
interface Exhibitor {
  id: string;
  name: string;
  standNumber: string;
  events: string[];
}
interface ExhibitorSelectorProps {
  exhibitors: Exhibitor[];
  selectedExhibitorId?: string;
  onSelect: (exhibitorId: string | null) => void;
  onCreateNew?: () => void;
  placeholder?: string;
}
export function ExhibitorSelector({
  exhibitors,
  selectedExhibitorId,
  onSelect,
  onCreateNew,
  placeholder = 'Search exhibitors...'
}: ExhibitorSelectorProps) {
  const [searchQuery, setSearchQuery] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const selectedExhibitor = exhibitors.find(ex => ex.id === selectedExhibitorId);
  const filteredExhibitors = exhibitors.filter(ex => ex.name.toLowerCase().includes(searchQuery.toLowerCase()) || ex.standNumber.toLowerCase().includes(searchQuery.toLowerCase()));
  const handleSelect = (exhibitorId: string) => {
    onSelect(exhibitorId);
    setIsOpen(false);
    setSearchQuery('');
  };
  const handleClear = () => {
    onSelect(null);
    setSearchQuery('');
  };
  return <div className="relative" data-id="element-3108">
      {selectedExhibitor ? <div className="flex items-center gap-2 p-3 border border-gray-300 rounded-lg bg-gray-50" data-id="element-3109">
          <BuildingIcon className="w-4 h-4 text-gray-500 flex-shrink-0" data-id="element-3110" />
          <div className="flex-1 min-w-0" data-id="element-3111">
            <div className="text-sm font-medium text-gray-900 truncate" data-id="element-3112">
              {selectedExhibitor.name}
            </div>
            <div className="text-xs text-gray-500" data-id="element-3113">
              Stand {selectedExhibitor.standNumber}
            </div>
          </div>
          <button onClick={handleClear} className="p-1 hover:bg-gray-200 rounded" type="button" data-id="element-3114">
            <XIcon className="w-4 h-4 text-gray-500" data-id="element-3115" />
          </button>
        </div> : <div className="relative" data-id="element-3116">
          <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" data-id="element-3117" />
          <input type="text" placeholder={placeholder} value={searchQuery} onChange={e => {
        setSearchQuery(e.target.value);
        setIsOpen(true);
      }} onFocus={() => setIsOpen(true)} className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm" data-id="element-3118" />
        </div>}

      {isOpen && !selectedExhibitor && <>
          <div className="fixed inset-0 z-10" onClick={() => setIsOpen(false)} data-id="element-3119" />
          <div className="absolute z-20 w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-lg max-h-64 overflow-y-auto" data-id="element-3120">
            {filteredExhibitors.length > 0 ? <div className="py-1" data-id="element-3121">
                {filteredExhibitors.map(exhibitor => <button key={exhibitor.id} type="button" onClick={() => handleSelect(exhibitor.id)} className="w-full px-4 py-2 text-left hover:bg-gray-50 flex items-center gap-3" data-id="element-3122">
                    <BuildingIcon className="w-4 h-4 text-gray-400 flex-shrink-0" data-id="element-3123" />
                    <div className="flex-1 min-w-0" data-id="element-3124">
                      <div className="text-sm font-medium text-gray-900 truncate" data-id="element-3125">
                        {exhibitor.name}
                      </div>
                      <div className="flex items-center gap-2 mt-1" data-id="element-3126">
                        <span className="text-xs text-gray-500 font-mono" data-id="element-3127">
                          {exhibitor.standNumber}
                        </span>
                        <div className="flex gap-1" data-id="element-3128">
                          {exhibitor.events.slice(0, 2).map(event => <Badge key={event} variant="default" size="sm" data-id="element-3129">
                              {event}
                            </Badge>)}
                        </div>
                      </div>
                    </div>
                  </button>)}
              </div> : <div className="px-4 py-8 text-center" data-id="element-3130">
                <BuildingIcon className="w-8 h-8 text-gray-300 mx-auto mb-2" data-id="element-3131" />
                <p className="text-sm text-gray-500 mb-3" data-id="element-3132">
                  No exhibitors found
                </p>
                {onCreateNew && <button type="button" onClick={() => {
            onCreateNew();
            setIsOpen(false);
          }} className="text-sm text-blue-600 hover:text-blue-700 font-medium" data-id="element-3133">
                    Create new exhibitor
                  </button>}
              </div>}
          </div>
        </>}
    </div>;
}